module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'contractorContacts',
        showHead: true,
        showIDs: true,
        // showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {},
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '105px',
        },
        rowActions: {
            edit: true,
            customs: [
                // {
                //     buttonType: 'showLocation',
                // },
                // {
                //     buttonType: 'delete',
                //     neutral: true,
                // }
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_contractorContacts': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'contractorContactID',
                direction: 'asc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, privilegeCode: 'bo_contractorContacts:create', }
                ]
            }
        },

        onSubmitDone(callerComponent, entityID, entityData, insertPerformed){
            switch(((callerComponent || {}).config || {}).entityContext){
                case 'contractorContacts':
                    const myContractorID = ((this.model.parentEntityForTable || {}).baseFilters || {}).contractorID
                    const foundContractorID = ((entityData || {}).attributes || {}).contractorID

                    if(myContractorID && foundContractorID && myContractorID == foundContractorID) {
                        if (insertPerformed && entityID && entityData) {
                            this.showEdit(entityID, entityData)
                        }
                    }
                    break;
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey
            if(
                refreshers[key] &&
                (
                    key === 'reconnect' ||
                    message.data.contractorID == ((this.model.parentEntityForTable || {}).baseFilters || {}).contractorID
                )
            ){
                this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
            }
        },
    }
}